module.exports = __webpack_public_path__ + "static/img/logo_luoohu.c93a970b.png";